import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { FormControl, FormGroup, FormBuilder, Validators, ValidatorFn, AbstractControl } from '@angular/forms';
import { SharedService, Status, RowsPerOptions } from '../../shared/shared.service';
import { BaseComponent } from '../../shared/base.component';
import { TranslateService } from '@ngx-translate/core';
import { WoService } from '../../work-order/work-order.service';
import { LoaderService } from '../../shared/loader.service';
import { GlobalInfo, Severities } from '../shared.model';
import { PartRequestEntity, AllocatePart, BOQPartsEntity } from 'app/layout/work-order/work-order-models';
import { CapitalizeFirstPipe } from '../pipes/custom-pipes.pipe';


@Component({
    selector: 'add-edit-boq-part-request-popup',
    templateUrl: 'add-edit-boq-part-request.html'
})

export class BOQPartRequestAddEditComponent extends BaseComponent implements OnInit {

    @Input() WorkOrderId: number;
    @Input() PartRequestId: number = 0;
    @Input() Part: PartRequestEntity = new PartRequestEntity();
    HeaderName: string;
    @Input() WoJobId: number;
    @Output() done = new EventEmitter();
    @Input() isOther: boolean = false;
    @Input() VendorApprovalstatus?: number;
    submitted: boolean = false;
    loader: boolean = false;
    showLookup: boolean = false;
    frmAddNewPart: FormGroup;
    jobList: any[] = [];
    gi: GlobalInfo;
    islookup: boolean = false;
    vendorId: number = 0;
    techId?: number = null;
    jobStatusId: number;
    jobCompletedStatus: boolean = false; // Added -  Edotco Production issue by KP on 18/05/2020
    constructor(protected sharedService: SharedService, protected translate: TranslateService, protected _woService: WoService,
        private loaderservice: LoaderService,
        private _fb: FormBuilder) {
        super(sharedService, translate);
        this.gi = super.globalInfo();
    }

    formInlialize() {
        this.frmAddNewPart = this._fb.group({
            WoJobId: ['', Validators.required],
            VendorName: [''],
            PartRequestNo: [''],
            RequestedQuantity: ['', Validators.required],
            RequestStatusId: [this.isOther == true ? 4 : 1],
            Notes: [''],
            ApprovedQty: [''],
            ApprovalRemark: [''],
            PartNo: ['', Validators.required],
            Uom: [''],
            Description: [''],
            VendorPrice: [''],
            BrandId: [''],
            ModelId: [''],
            PartId: [''],
            WoPartPriceId: [0],
            ApprovalStatusId: [this.isOther == true ? 3 : 2]
        });
        if (this.VendorApprovalstatus == 1)
            this.jobCompletedStatus = true;
    }


    ngOnInit() {
        this.formInlialize();
        this.doGet();
    }

    doGet() {
        if (this.PartRequestId == 0) {
            this.showLookup = true;
            this.HeaderName = this.translate.instant("ADDBOQPARTREQUEST");
            this.loaderservice.show();
            this._woService.getJobId(this.gi.CompanyId, this.WorkOrderId)
                .subscribe(s => {
                    this.loaderservice.hide();
                    this.jobList = s;
                    this.frmAddNewPart.patchValue({
                        WoJobId: (this.WoJobId > 0 ? this.WoJobId : ((this.jobList.length > 0) ? this.jobList[0].WoJobId : ''))
                    });

                    if (this.jobList.length > 0) {
                        this.vendorId = this.jobList[0].VendorId == null ? 0 : this.jobList[0].VendorId;
                        this.techId = this.jobList[0].TechId;
                        debugger;
                        this.jobStatusId = this.jobList[0].JobStatusId;
                    }

                    this.ChangeJobId();

                }, e => {
                    this.loaderservice.hide();
                });

        }
        else {
            this.loaderservice.show();
            this.vendorId = this.Part.VendorId;
            this._woService.getByPartRequest(this.gi.CompanyId, this.PartRequestId, this.Part.VendorId).subscribe(
                s => {
                    this.frmAddNewPart.patchValue({
                        WoJobId: s.WoJobId,
                        VendorName: s.VendorName,
                        PartRequestNo: s.PartRequestNo,
                        RequestedQuantity: s.RequestedQty,
                        RequestStatusId: s.RequestStatusId,
                        Notes: s.PartNotes,
                        ApprovedQty: s.ApprovedQty,
                        ApprovalRemark: s.ApprovalStatusId == 3 ? s.ApproveReason : s.RejectReason,
                        PartNo: s.PartNo,
                        Uom: s.Uom,
                        Description: s.Description,
                        VendorPrice: s.UnitPrice,
                        BrandId: s.BrandId,
                        ModelId: s.ModelId,
                        PartId: s.PartId,
                        WoPartPriceId: s.WoPartPriceId,
                        ApprovalStatusId: s.ApprovalStatusId
                    });
                    this.jobStatusId = s.JobStatusId;
                    this.techId = s.BOQTechId;
                    this.loaderservice.hide();
                },
                e => {
                    this.loaderservice.hide();
                }
            );
            this.HeaderName = this.translate.instant("EDITBOQPARTREQUEST");
        }
    }

    ChangeJobId() {
        let jobid = this.frmAddNewPart.value.WoJobId;
        let vendorName = "";
        if (jobid) {
            let detail = this.jobList.find(f => f.WoJobId == jobid);
            this.vendorId = detail.VendorId == null ? 0 : detail.VendorId;
            this.techId = detail.TechId;
            vendorName = detail.VendorName;
            this.jobStatusId = detail.JobStatusId;
            // Added jobCompletedStatus -  Edotco Production issue by KP on 18/05/2020 Start
            if (this.jobStatusId == 1 || this.jobStatusId == 6 || this.jobStatusId == 8) {
                this.jobCompletedStatus = true;
            }
            else if (this.jobStatusId == 5 || this.jobStatusId == 7) {
                if (this.jobStatusId == 5 && this.VendorApprovalstatus == 1) {
                    this.jobCompletedStatus = true;
                }
                else {
                    this.jobCompletedStatus = false;
                }
            }
            else {
                this.jobCompletedStatus = true;
            }

            // Added  jobCompletedStatus -  Edotco Production issue by KP on 18/05/2020 End


        }
        else {
            this.vendorId = 0;
            this.techId = null;
        }
        if (this.PartRequestId == 0) {
            this.frmAddNewPart.patchValue({
                VendorName: vendorName,
                // WoJobId: jobid,
                PartNo: '',
                Uom: '',
                Description: '',
                VendorPrice: '',
                BrandId: '',
                ModelId: '',
                PartId: '',
                WoPartPriceId: 0
            });
        }
    }

    addOrEditPart() {
        this.submitted = true;
        if (this.frmAddNewPart.valid) {
            let model = this.frmAddNewPart.value;
            let entity: BOQPartsEntity = {
                BrandId: model.BrandId,
                CompanyId: this.gi.CompanyId,
                CreatedBy: this.gi.LoginId,
                IsBOQRequest: 1,
                JobId: model.WoJobId,
                LastChangedBy: this.gi.LoginId,
                ModelId: model.ModelId,
                PartId: model.PartId,
                PartNotes: model.Notes,
                PartRequestId: this.PartRequestId,
                Price: model.VendorPrice,
                ReqQty: model.RequestedQuantity,
                RequestStatusId: model.RequestStatusId,
                SourceID: 1,
                VendorId: this.vendorId,
                WorkOrderId: this.WorkOrderId,
                loginid: this.gi.LoginId,
                ApprovalStatusId: model.ApprovalStatusId,
                WoPartPriceId: model.WoPartPriceId,
                BOQTechId: this.techId,
                ApprovedQty: model.ApprovedQty
            }

            if (this.jobStatusId == 5) {
                entity.ApprovalStatusId = 3;
                entity.RequestStatusId = 4;
                entity.ApprovedQty = entity.ReqQty;
            }

            if (entity.ReqQty <= 0) {
                this.sharedService.notification.emit({ severity: Severities[Severities.error], summary: CapitalizeFirstPipe.prototype.transform(Severities[Severities.error]), detail: this.translate.instant('REQUESTEDQUANTITYGREATER') });
            }
            else {
                this.loaderservice.show();
                this._woService.InsertUpdateBOQPartRequest(entity).subscribe(
                    s => {
                        this.loaderservice.hide();
                        if (s.PoErrorCode == "1001") {
                            if (this.PartRequestId == 0) {
                                this.sharedService.notification.emit({
                                    severity: Severities[0],
                                    summary: CapitalizeFirstPipe.prototype.transform(Severities[0]),
                                    detail: this.translate.instant('BOQPARTREQUESTCREATEDSUCCESSFULLY')
                                });
                            }
                            else {
                                this.sharedService.notification.emit({
                                    severity: Severities[0],
                                    summary: CapitalizeFirstPipe.prototype.transform(Severities[0]),
                                    detail: this.translate.instant('BOQPARTREQUESTUPDATEDSUCCESSFULLY')
                                });
                            }
                            this.closePopup(true);
                        }
                    },
                    e => {
                        this.loaderservice.hide();
                    }
                );
            }
        }
    }

    openPartLookup() {
        this.islookup = true;
    }

    closePopup(refresh: boolean = false) {
        this.done.emit(refresh);
    }

    closesearch(obj: any) {
        let data = obj.data
        if (data) {
            this.frmAddNewPart.patchValue({
                PartNo: data.PartNo,
                Uom: data.Uom,
                Description: data.Description,
                VendorPrice: data.VendorPrice,
                BrandId: data.BrandId,
                ModelId: data.ModelId,
                PartId: data.PartId
            });
        }
        this.islookup = false;
    }

    isNumberKey(event, allowDot: boolean = false) {
        var charCode = (event.which) ? event.which : event.keyCode;
        if (event.shiftKey)
            return false;

        if (charCode > 31 && (charCode < 48 || charCode > 57) && !(charCode == 46 || charCode == 8))
            return false;
        else {
            if (!allowDot && (charCode == 46 || charCode == 8))
                return false;

            var len = event.target.value.length;
            var index = event.target.value.indexOf('.');
            if (index > 0 && charCode == 46)
                return false;
            if (index > 0) {
                var CharAfterdot = (len + 1) - index;
                if (CharAfterdot > 3)
                    return false;
            }
        }
        return true;
    }
}